export enum ETipoContaBancaria {
  ContaCorrente = 1,
  ContaPoupanca = 2,
}
